<template>
  <Transition name="sidebar" appear>
    <slot />
  </Transition>
</template>

<style lang="scss">
.sidebar {
  &-enter-active {
    @apply duration-300 ease-in will-change-transform;

    .dialog-overlay {
      @apply duration-300 opacity-0;
    }

    .dialog-panel {
      @apply duration-300 -translate-x-full;
    }
  }

  &-enter-to {
    .dialog-overlay {
      @apply opacity-100;
    }

    .dialog-panel {
      @apply translate-x-0;
    }
  }

  &-leave-active {
    @apply duration-300 ease-out;

    .dialog-overlay, .dialog-panel {
      @apply duration-300;
    }
  }

  &-leave-to {
    .dialog-overlay {
      @apply opacity-0;
    }

    .dialog-panel {
      @apply -translate-x-full;
    }
  }
}
</style>
